<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="top">
        <img src="@/assets/read/rule-title.png" alt="" class="imgBase" />
      </div>
      <div class="input">
        <van-search
          clearable
          @clear="clear()"
          show-action
          v-model="value"
          placeholder="请输入选手编号或名称"
        >
        </van-search>
      </div>
      <div class="searchBtn" >
        <van-button class="btn" @click="gotoVote()" type="primary">搜索</van-button>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
};
</script>

<style lang="less" scoped>
.search {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 8.8rem;
    box-sizing: border-box;
    position: relative;
    background-color: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    div.top {
      height: 0.6rem;
      width: 5.57rem;
      margin-top: .4rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .input {
      margin: .6rem 0.4rem;
      width: 7rem;
      color: #444;
      .van-search {
        padding: 0 0 0 2px;
        .van-search__content {
          background: transparent;
          padding: 2px 0;
          border: 1px solid #45d3c0;
        }
      }
      /deep/.van-search .van-cell {
        padding: 0px 8px;
        background: #fff !important;
      }
      .van-search__action {
        width: 2rem;
        text-align: center;
        color: #fff;
        padding: 0;
        line-height: 1.1733333rem;
        display: none;
        .searchBtn {
          color: #fff;
          position: relative;
          box-sizing: border-box;
          font-size: 0.4266667rem;
          letter-spacing: 0.0533333rem;
        }
      }
    }
    .searchBtn {
        height: .96rem;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: .6rem;
        display: grid;
        justify-content: center;
         
        .btn {
          width: 5rem !important;
          height: .762rem !important;
          background: url('@/assets/read/button-303.png')  no-repeat;
          background-size: 100% 100% !important;
        }
        .van-button {
          width: 100%;
          height: 100%;
          border: none;
        }
      }
  }
  div.close {
    margin-top: 0.5333333rem;
    .van-icon-close {
      font-size: 0.96rem;
      color: #fff;
    }
  }
}
</style>